import { FiTruck, FiAward, FiShield, FiHeadphones } from "react-icons/fi";

const BADGES = [
  { Icon: FiTruck, title: "Fast Shipping", subtitle: "Free and fast delivery" },
  { Icon: FiAward, title: "Genuine Products", subtitle: "Genuine & original products" },
  { Icon: FiShield, title: "Secure Checkout", subtitle: "Protected payments" },
  { Icon: FiHeadphones, title: "Online Support", subtitle: "Dedicated online support" },
];

export default function TrustBadges() {
  return (
    <section className="mb-20">
      <div className="container mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-[30px]">
          {BADGES.map(({ Icon, title, subtitle }) => (
            <div key={title} className="flex flex-col items-center text-center gap-y-2">
              <Icon className="text-3xl text-brand" />
              <div className="font-medium text-ink">{title}</div>
              <div className="text-sm text-muted">{subtitle}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
